import React from 'react';
import { motion } from 'framer-motion';

const PolitiqueCookiesPage = () => {
    return (
        <div className="min-h-screen bg-gray-900 text-white">
            <div className="container mx-auto px-4 py-4 md:py-8 lg:py-12">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                    className="container mx-auto px-4 py-8 md:py-12 lg:py-16 bg-gray-900 text-white"
                >
                    <h1 className="text-3xl font-bold text-center mb-8 text-white">Politique de Cookies</h1>
                    <p className="text-gray-300">
                        Dernière mise à jour : 02 / 04 / 2025
                    </p>
                    <p className="text-gray-300">
                        Sev Remorque s'engage à protéger la confidentialité de vos informations personnelles.<br />
                        Cette politique explique comment nous utilisons les cookies et autres technologies de suivi sur notre site web.<br />
                        <a 
                                href="https://www.dépannage-occitanie.com"
                                className="text-1xl font-semibold text-yellow-200"
                            >
                                https://www.dépannage-occitanie.com
                            </a>
                    </p>

                    <br /><br />
                    <section className="mb-8 space-y-4">
                        <h2 className="text-2xl font-semibold text-yellow-400">1. Informations sur les cookies</h2>
                        <p className="text-gray-300">
                            Les cookies sont de petits fichiers texte qui sont placés sur votre appareil (ordinateur, smartphone, tablette)
                            lorsque vous naviguez sur un site web. Ils sont largement utilisés pour faire fonctionner les sites web,
                            ou pour fonctionner plus efficacement, ainsi que pour fournir des informations aux propriétaires du site.
                        </p>
                    </section>

                    <section className="mb-8 space-y-4">
                        <h2 className="text-2xl font-semibold text-yellow-400">2. Comment nous utilisons les cookies</h2>
                        <p className="text-gray-300">
                            Actuellement, notre site web <a 
                                href="https://www.dépannage-occitanie.com"
                                className="text-1xl font-semibold text-yellow-200"
                            >
                                https://www.dépannage-occitanie.com
                            </a> n'utilise aucun cookie. Par conséquent, aucune information n'est collectée
                            via des cookies à l'heure actuelle.
                        </p>
                    </section>

                    <section className="mb-8 space-y-4">
                        <h2 className="text-2xl font-semibold text-yellow-400">3. Cookies tiers</h2>
                        <p className="text-gray-300">
                            Notre site web <a 
                                href="https://www.dépannage-occitanie.com"
                                className="text-1xl font-semibold text-yellow-200"
                            >
                                https://www.dépannage-occitanie.com
                            </a> peut contenir des liens vers d'autres sites web qui peuvent utiliser des cookies.
                            Nous n'avons aucun contrôle sur ces cookies et nous vous recommandons de consulter la politique de cookies
                            du site web tiers concerné pour plus d'informations.
                        </p>
                    </section>

                    <section className="mb-8 space-y-4">
                        <h2 className="text-2xl font-semibold text-yellow-400">4. Vos choix</h2>
                        <p className="text-gray-300">
                            Puisque nous n'utilisons pas de cookies, il n'y a aucune action requise de votre part concernant les cookies.
                            Cependant, si nous devions implémenter des cookies à l'avenir, nous mettrons à jour cette politique et
                            vous informerons de vos choix concernant les cookies.
                        </p>
                    </section>

                    <section className="mb-8 space-y-4">
                        <h2 className="text-2xl font-semibold text-yellow-400">5. Modifications de cette politique</h2>
                        <p className="text-gray-300">
                            Nous pouvons modifier cette politique de cookies à tout moment. Toute modification sera publiée sur cette page.
                            Nous vous encourageons à consulter régulièrement cette politique de cookies pour vous tenir informé de nos
                            pratiques en matière de cookies.
                        </p>
                    </section>

                    <section className="mb-8 space-y-4">
                        <h2 className="text-2xl font-semibold text-yellow-400">6. Nous contacter</h2>
                        <p className="text-gray-300">
                            Si vous avez des questions concernant cette politique de cookies, veuillez nous contacter :
                        </p>
                        <p className="text-gray-300">
                            Sev Remorque
                        </p>
                        <p className="text-gray-300">
                            66000 PERPIGNAN, 41 Rue des oiseaux
                        </p>
                        <p className="text-gray-300">
                            severincortes7@gmail.com
                        </p>
                        <p className="text-gray-300">
                            06.99.46.31.59
                        </p>
                    </section>
                </motion.div>
            </div>
        </div>
    );
};

export default PolitiqueCookiesPage;
